import { render } from "./Affix.vue?vue&type=template&id=8c1160c2&scoped=true"
import script from "./Affix.vue?vue&type=script&lang=js"
export * from "./Affix.vue?vue&type=script&lang=js"

import "./Affix.vue?vue&type=style&index=0&id=8c1160c2&scoped=true&lang=scss"
import "./Affix.vue?vue&type=style&index=1&id=8c1160c2&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1160c2"]])

export default __exports__